export * from "./update-device-page.component";
export * from "./base-create-device-page.component";
